import React from 'react';
import { useNavigate } from 'react-router-dom';

function AdminCommon() {
  const navigate = useNavigate();

  return (
    <div style={{ padding: 30 }}>
      <h1>🛠️ Admin Panel</h1>

      <div style={{ marginTop: 30, display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
        <button
          onClick={() => navigate('/adminupload')}
          style={{ padding: '10px 20px' }}
        >
          📤 Upload Poster Data
        </button>

        <button
          onClick={() => navigate('/posterdata')}
          style={{ padding: '10px 20px' }}
        >
          📑 View Poster Data
        </button>

        <button
          onClick={() => navigate('/musicscanner')}
          style={{ padding: '10px 20px' }}
        >
          🎵 All Music QR Codes
        </button>

        <button
          onClick={() => navigate('/holoscanner')}
          style={{ padding: '10px 20px' }}
        >
          🌐 All Hologram QR Codes
        </button>

         <button
          onClick={() => navigate('/avatar')}
          style={{ padding: '10px 20px' }}
        >
          🥺 All Avatar QR Codes
        </button>

         <button
          onClick={() => navigate('/zoneqr')}
          style={{ padding: '10px 20px' }}
        >
           All Zone QR Codes
        </button>
      </div>
    </div>
  );
}

export default AdminCommon;
